import React, { Component } from "react";


import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";

// datatable related plugins
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import RemoteTable from "../../../components/Common/RemoteTable";
import SweetAlert from "react-bootstrap-sweetalert";
import styled from "styled-components";
import {
  getInvoiceTemplateList,
  addInvoiceTemplate,
  updateInvoiceTemplate,
  deleteInvoiceTemplate,
} from "../../../store/invoice_templates/actions";
import ModalInvoiceTemplates from "./common/ModalInvoiceTemplates";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class InvoiceTemplates extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      deleteAlert: null,
      viewAddInvoiceTemplates: false,
      editData: null,
    };

    this.searchTimer = null;
  }

  componentDidMount() {
    this.props.getInvoiceTemplateList(this.props.data);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {}

  handleTableChange = data => {
    this.props.getInvoiceTemplateList(data);
  };

  handleChangeDeleteAlert = data => {
    this.setState({ deleteAlert: data });
  };

  toggleViewAddInvoiceTemplates = () => {
    this.setState(prevState => ({
      viewAddInvoiceTemplates: !prevState.viewAddInvoiceTemplates,
      editData: null,
    }));
  };

  render() {
    const actionsFormatter = (cell, row) => {
      const onClickDelete = () => {
        this.handleChangeDeleteAlert({
          title: `Delete "${row.name}"!`,
          onConfirm: () => {
            this.props.deleteInvoiceTemplate(row.id, {
              ...this.props.data,
              page:
                this.props.data.results.length === 1 ? 1 : this.props.data.page,
            });
            this.handleChangeDeleteAlert(null);
          },
        });
      };

      const onClickEdit = e => {
        onClickRow(e, row, "edit");
      };

      return (
        <React.Fragment>
          {this.props.permissions["change_invoicetemplatemodel"] && (
            <Button
              type="button"
              className="btn btn-primary  btn-sm"
              onClick={onClickEdit}
            >
              <i className="mdi mdi-circle-edit-outline d-block font-size-16" />
            </Button>
          )}
          {this.props.permissions["delete_invoicetemplatemodel"] && (
            <Button
              type="button"
              className="btn btn-danger btn-sm m-1"
              onClick={onClickDelete}
            >
              <i className="mdi mdi-trash-can d-block font-size-16" />
            </Button>
          )}
        </React.Fragment>
      );
    };

    const nameFormatter = (cell, row, label) => {
      return (
        <NameLink onClick={e => onClickRow(e, row, "edit")}>
          {row[label]}
        </NameLink>
      );
    };

    const onClickRow = (e, row, type) => {
      if (this.props.permissions?.["view_invoicetemplatemodel"]) {
        this.setState(prevState => ({
          viewAddInvoiceTemplates: !prevState.viewAddInvoiceTemplates,
          editData: type === "edit" ? row : null,
        }));
      }
    };

    const fileFormatter = (cell, row) => {
      return (
        <Col className="col-auto me-2">
          <NameLink onClick={e => onClickRow(e, row, "edit")}>
            {row.file.split("/").pop()}
          </NameLink>
          <a
            href={row?.file.replace("http", "https") || ""}
            className="ms-2"
            download
          >
            <StyledDownload className="mdi  mdi-download font-size-22 align-middle text-primary " />
          </a>
        </Col>
      );
    };

    const columns = [
      {
        dataField: "name",
        text: "Name",
        sort: true,
        formatter: (cell, row) => nameFormatter(cell, row, "name"),
      },
      // {
      //   dataField: "file",
      //   text: "File",
      //   sort: true,
      //   formatter: (cell, row) => fileFormatter(cell, row),
      // },
      {
        dataField: "actions",
        text: "Actions",
        sort: false,
        formatter: actionsFormatter,
      },
    ];

    return (
      <React.Fragment>
        {this.state.viewAddInvoiceTemplates && (
          <ModalInvoiceTemplates
            toggle={this.toggleViewAddInvoiceTemplates}
            isOpen={this.state.viewAddInvoiceTemplates}
            data={this.props.data}
            addInvoiceTemplate={this.props.addInvoiceTemplate}
            updateInvoiceTemplate={this.props.updateInvoiceTemplate}
            editData={this.state.editData}
            permissions={this.props.permissions}
          />
        )}
        <div className="page-content">
        <ModifiedMetaTags title="Invoice templates | Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Dashboard"
              breadcrumbItem="Invoice Templates"
              link="/dashboard"
            />
            {this.state.deleteAlert && (
              <SweetAlert
                showCancel
                confirmBtnText="Delete"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle=""
                title={this.state.deleteAlert.title}
                onCancel={() => this.handleChangeDeleteAlert(null)}
                onConfirm={this.state.deleteAlert.onConfirm}
              >
                <p>
                  You are about to delete this invoice template? <br /> If you
                  are not sure, you can close this form.
                </p>
              </SweetAlert>
            )}

            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <RemoteTable
                      onTableChange={this.handleTableChange}
                      columns={columns}
                      data={this.props.data}
                      loading={this.props.loading}
                    >
                      {this.props.permissions &&
                        this.props.permissions["add_invoicetemplatemodel"] ===
                          "add_invoicetemplatemodel" && (
                          <Button
                            type="button"
                            color="success"
                            className="btn-rounded mb-2 me-2"
                            onClick={this.toggleViewAddInvoiceTemplates}
                          >
                            <i className="mdi mdi-plus me-1" /> Add template
                          </Button>
                        )}
                    </RemoteTable>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const NameLink = styled.span`
  transition-duration: 0.1s;
  &:hover {
    color: rgb(85, 110, 230);
    transition-duration: 0.1s;
  }
`;

const StyledDownload = styled.i`
  opacity: 0.8;
  transition: 0.5s;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
`;

InvoiceTemplates.propTypes = {
  data: PropTypes.shape({
    page: PropTypes.number,
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  getInvoiceTemplateList: PropTypes.func.isRequired,
  addInvoiceTemplate: PropTypes.func.isRequired,
  updateInvoiceTemplate: PropTypes.func.isRequired,
  deleteInvoiceTemplate: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  permissions: PropTypes.any.isRequired,
};

const mapStateToProps = state => ({
  data: state.InvoiceTemplates.data,
  loading: state.InvoiceTemplates.loading,
  permissions: state.User.permissions,
});

export default connect(mapStateToProps, {
  getInvoiceTemplateList,
  addInvoiceTemplate,
  updateInvoiceTemplate,
  deleteInvoiceTemplate,
})(InvoiceTemplates);
